<template>
  <div class='section'>
    <div class='section-title'>
      <h1>사고대차</h1>
    </div>
    <div class='section-title-underline'></div>
    <div class='section-title-description'>
      <div class='section-title-description-sub'>
        <p>상대방 과실의 사고로 인하여 수리기간 동안 동급 이상의</p>
        <p>다양한 차종을 무상으로 렌탈 받을 수 있는 서비스를 제공하고 있습니다.</p>
      </div>
    </div>
    <div class='section-content'>
      <table>
        <tr>
          <td>
            <div class='section-content-img'>
              <img src='../assets/ferrai-red.png'>
            </div>
          </td>
          <td>
            <div clsss='section-content-article'>
              <p>- 별도의 대여료 결제 없이 이용가능</p>
              <p>- 무상 딜리버리 서비스 제공</p>
              <p>- 국산차 사고시 수입차 대차 이용 가능</p>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>

</template>

<script>


  export default {
    components: {

    }
  }
</script>

<style scoped>
  .section-title-description-sub p{
    font-size: 2em;
    word-break: keep-all;
  }
  .section-content {
    align-items: center;
    margin-top: 9.18em;
    margin-bottom: 9.18em;
  }
  .section-content p {
    font-family: s-core5;
    font-size: 3em;
    margin: 0.5em;
    word-break: keep-all;
  }
  .section-content-img img {
    width: 51em;
  }
  .section-content-article p{
    word-break: keep-all;
  }

  /* media */
  @media (max-width: 1660px){
    .section-content-img img {
      width: 30em;
    }
  }
  @media (max-width: 1264px){
    .section-content-img img {
      width: 30em;
    }
    .section-content p {
      font-size: 2em;
    }
  }
  @media (max-width: 1100px){
    .section-content-img img {
      width: 35em;
    }
    .section-content p {
      font-size: 2em;
    }
  }
  /* mobile */
  @media (max-width: 710px){
    .section-content-img img {
      width: 30em;
    }
    .section-content p {
      font-size: 1.6em;
    }
  }

</style>
